type Props = {
  children: any | JSX.Element | JSX.Element[];
};

function PageContainer({ children }: Props) {
  return <div>{children}</div>;
}

export default PageContainer;
